export type DashboardPeriod = '7d' | '30d' | '90d';

export const queryKeys = {
  me: ['me'] as const,
  dashboardStats: (period: DashboardPeriod) => ['dashboard', 'stats', period] as const,
  ranking: (metric: string, period: DashboardPeriod) =>
    ['dashboard', 'ranking', metric, period] as const,
  meeting: (id: string) => ['meeting', id] as const,
  meetings: (filters: Record<string, unknown>) => ['meetings', filters] as const,
  search: (q: string, filters: Record<string, unknown>) => ['search', q, filters] as const,
  consent: (meetingId: string) => ['consent', meetingId] as const,
  knowledgeList: (filters: Record<string, unknown>) => ['knowledge', filters] as const,
  summariesList: (q: string) => ['summaries', q] as const,
  billingConfig: ['billing', 'config'] as const,
  billingMultipliers: ['billing', 'multipliers'] as const,
  billingPlans: ['billing', 'plans'] as const,
  billingPrices: ['billing', 'prices'] as const,
} as const;
